module.exports = __webpack_public_path__ + "static/media/iconfont.17e812f1.ttf";